import { useState, ReactNode } from 'react';
import AnalyticsContext, { ContextData } from '@/contexts/analytics/analytics-context';

interface AnalyticsProviderProps {
  children: ReactNode;
  eventPrefix: string;
}

export default function AnalyticsProvider({ children, eventPrefix }: AnalyticsProviderProps) {
  const [data] = useState({
    eventPrefix,
  });
  const [context, setContext] = useState<ContextData>({
    quoteId: null,
    agentId: null,
    agencyId: null,
    publicId: null,
    experience: null,
    quoteSource: null,
    experiments: {},
  });

  return <AnalyticsContext.Provider value={{ ...data, context, setContext }}>{children}</AnalyticsContext.Provider>;
}
